module.exports = __webpack_public_path__ + "img/Wp_2007.253729af.png";